import { render, staticRenderFns } from "./create.vue?vue&type=template&id=d24a9e08&scoped=true&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"
import style0 from "../../../../assets/css/common/nav.less?vue&type=style&index=0&id=d24a9e08&scoped=true&lang=less&"
import style1 from "./create.vue?vue&type=style&index=1&id=d24a9e08&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24a9e08",
  null
  
)

export default component.exports